import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ABOUT_PAGE_ABOUT_CEO, ABOUT_PAGE_ABOUT_COMMITMENT_TO_INNOVATION, ABOUT_PAGE_ABOUT_US, ABOUT_PAGE_ABOUT_WHY_CHOOSE_US, ABOUT_PAGE_CONTACT_US_PARA1, ABOUT_PAGE_CONTACT_US_PARA2, ABOUT_PAGE_CORE_VALUES, ABOUT_PAGE_OUR_MISSION, ABOUT_PAGE_OUR_VISION, ABOUT_PAGE_PRODUCTS_AND_SOLUTION, CONTACT_US_ADDRESS_MAIN, CONTACT_US_EMAIL_MAIN, CONTACT_US_PHONE_MAIN, CONTACT_US_WEB_MAIN, SITE_TITLE } from '../../shared/constants';
import ABOUT_PAGE_ABOUT_US_FULL from './content/about-us-full.content.html';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  constructor(private meta: Meta, private title: Title) { }

  ABOUT_PAGE_ABOUT_US_FULL: string = ABOUT_PAGE_ABOUT_US_FULL
  ABOUT_PAGE_ABOUT_US: string = ABOUT_PAGE_ABOUT_US
  ABOUT_PAGE_OUR_VISION: string = ABOUT_PAGE_OUR_VISION
  ABOUT_PAGE_OUR_MISSION: string = ABOUT_PAGE_OUR_MISSION
  ABOUT_PAGE_CORE_VALUES: string = ABOUT_PAGE_CORE_VALUES
  ABOUT_PAGE_PRODUCTS_AND_SOLUTION: string = ABOUT_PAGE_PRODUCTS_AND_SOLUTION
  ABOUT_PAGE_ABOUT_COMMITMENT_TO_INNOVATION: string = ABOUT_PAGE_ABOUT_COMMITMENT_TO_INNOVATION
  ABOUT_PAGE_ABOUT_WHY_CHOOSE_US: string = ABOUT_PAGE_ABOUT_WHY_CHOOSE_US
  ABOUT_PAGE_CONTACT_US_PARA1: string = ABOUT_PAGE_CONTACT_US_PARA1
  ABOUT_PAGE_CONTACT_US_PARA2: string = ABOUT_PAGE_CONTACT_US_PARA2
  ABOUT_PAGE_ABOUT_CEO: string = ABOUT_PAGE_ABOUT_CEO;

  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN
  CONTACT_US_EMAIL_MAIN: string = CONTACT_US_EMAIL_MAIN
  CONTACT_US_WEB_MAIN: string = CONTACT_US_WEB_MAIN
  CONTACT_US_ADDRESS_MAIN: string = CONTACT_US_ADDRESS_MAIN

  ngOnInit(): void {
    this.title.setTitle(SITE_TITLE + ' | About Company!');
    this.meta.updateTag({ name: 'description', content: 'NordNative is a SaaS company focused on sales and marketing automation.' });
    this.meta.updateTag({ name: 'keywords', content: 'About NordNative, Nord Native, NordNative OÜ, sales automation, marketing automation' });
  }
}
